'use strict';

var POSTER_SIZES = [{ id: '30x40cm' }, { id: '50x70cm' }, { id: '70x100cm' }];

var POSTER_ORIENTATIONS = [{ id: 'portrait' }, { id: 'landscape' }];

module.exports = {
  POSTER_SIZES: POSTER_SIZES,
  POSTER_ORIENTATIONS: POSTER_ORIENTATIONS
};


//////////////////
// WEBPACK FOOTER
// ./~/alvarcarto-common/dist/enums.js
// module id = 606
// module chunks = 0